import { useAtomValue } from 'jotai';

import { VisitorState, visitorStateAtom } from '../state';
import { RoomLoader } from './RoomLoader';
import { useTrackJoiningSessionLoaderViewedEvent } from './useTrackJoiningSessionLoaderViewedEvent';

export function RoomLoaderWrapper() {
  const visitorState = useAtomValue(visitorStateAtom);
  const isLoading = visitorState === VisitorState.LOADING;
  useTrackJoiningSessionLoaderViewedEvent(isLoading);
  return <RoomLoader shouldShow={isLoading} />;
}
